import Params               from "dashboard/dist/Core/Params";
import { setSection }       from "Actions/Core/CoreActions";
import { GuideSection }     from "Utils/API";

// Types
import {
    GUIDE_SECTION, GUIDE_SECTION_LOADING,
    GUIDE_SECTION_LIST, GUIDE_SECTION_ELEM, GUIDE_SECTION_CREATE,
} from "Utils/Types";



/**
 * Fetches the Section List
 * @param {String=} type
 * @param {Number=} elemID
 * @param {Object=} params
 * @returns {(dispatch) => Void}
 */
export function fetchSections(type = "", elemID = 0, params = {}) {
    return async (dispatch) => {
        dispatch({ type : GUIDE_SECTION_LOADING });
        Params.unset(params);
        let data = {};

        switch (type) {
        case "GUIDE":
            params.guideID = elemID;
            data = await GuideSection.getAllForGuide(params);
            break;
        default:
        }
        data.sort = params;
        dispatch({ type : GUIDE_SECTION_LIST, data });
        dispatch(setSection(GUIDE_SECTION));
    };
}

/**
 * Fetches a single Section
 * @param {Number} sectionID
 * @returns {(dispatch) => Void}
 */
export function fetchSection(sectionID) {
    return async (dispatch) => {
        const data = await GuideSection.getOne({ sectionID });
        dispatch({ type : GUIDE_SECTION_ELEM, data });
    };
}

/**
 * Fetches the Section Create data
 * @param {Number} guideID
 * @returns {(dispatch: Function) => Void}
 */
export function fetchSectionCreate(guideID) {
    return async (dispatch) => {
        const data = await GuideSection.getCreateData({ guideID });
        dispatch({ type : GUIDE_SECTION_CREATE, data });
    };
}



/**
 * Edits/Creates a Section
 * @param {Object} data
 * @returns {() => Void}
 */
export function editSection(data) {
    return () => GuideSection.edit(data);
}

/**
 * Deletes a Section
 * @param {Number} sectionID
 * @returns {() => Void}
 */
export function deleteSection(sectionID) {
    return () => GuideSection.delete({ sectionID });
}
